<form [formGroup]="form">
  <div id="board-write">
    <div class="inner-wrap1">
      <table>
      <colgroup>
        <col style="width:14%">
        <col style="width:36%">
        <col style="width:14%">
        <col style="width:36%">
      </colgroup>

      <tbody>
      <ng-container *ngIf="group.length > 0">
        <tr>
          <th><i class="material-icons cred f11">star</i>구분</th>
          <td colspan="3">
            <select id="group_id" formControlName="group_id" [ngClass]="{formErrors:formErrors['group_id']}">
              <option *ngFor="let item of group" [value]="item.value">{{item.title}}</option>
            </select>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="params.board_id !== 'ahriconsult'">
        <tr>
          <th><i class="material-icons cred f11">star</i>제목</th>
          <td colspan="3"><input type="text" id="subject" formControlName="subject" [ngClass]="{formErrors:formErrors['subject']}" autofocus="true" /></td>
        </tr>
      </ng-container>

      <tr>
        <th><i class="material-icons cred f11">star</i>내용</th>
        <td colspan="3">
          <textarea class="contents" id="contents" formControlName="contents" [ngClass]="{formErrors:formErrors['contents']}"></textarea>
        </td>
      </tr>
      </tbody>
      </table>

      <div class="btn-area">
        <button class="add-btn" (click)="write()">등록</button>
        <button class="list-btn" (click)="list()">취소</button>
      </div>
    </div>
  </div>
</form>
